export default __webpack_public_path__ + "images/avatar-default.d04e51c6a65ad77c455e041953878408.svg";